// Imágenes de ejemplo en alta definición para diferentes secciones
// Fuente: Unsplash (gratis para uso comercial)

export const exampleImages = {
  // Imágenes para noticias/convocatorias relacionadas con gobierno
  gobierno: [
    'https://images.unsplash.com/photo-1582213782179-e0d53f98f2ca?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80',
    'https://images.unsplash.com/photo-1556761175-5973dc0f32e7?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80',
    'https://images.unsplash.com/photo-1551836022-d5d88e9218df?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80',
    'https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80',
    'https://images.unsplash.com/photo-1556761175-b413da4baf72?ixlib=rb-4.0.3&auto=format&fit=crop&w=1974&q=80',
    'https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80'
  ],
  
  // Imágenes para eventos y convocatorias (conv.jpg = imagen de referencia convocatoria laboral)
  eventos: [
    '/images/conv.jpg',
    'https://images.unsplash.com/photo-1511578314322-379afb476865?ixlib=rb-4.0.3&auto=format&fit=crop&w=2069&q=80',
    'https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80',
    'https://images.unsplash.com/photo-1540575467063-178a50c2df87?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80'
  ],
  
  // Imágenes para transparencia y contratación
  transparencia: [
    'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80',
    'https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80'
  ],
  
  // Imágenes para comunidad y ciudadanía
  comunidad: [
    'https://images.unsplash.com/photo-1521737604893-d14cc237f11d?ixlib=rb-4.0.3&auto=format&fit=crop&w=2084&q=80',
    'https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80',
    'https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80'
  ],
  
  // Imagen para hero (ya está en el CSS)
  hero: 'https://images.unsplash.com/photo-1556761175-5973dc0f32e7?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80'
};

// Función para obtener una imagen aleatoria de una categoría
export const getRandomImage = (category = 'gobierno') => {
  const images = exampleImages[category] || exampleImages.gobierno;
  return images[Math.floor(Math.random() * images.length)];
};

// Función para obtener imagen basada en el índice (para consistencia)
export const getImageByIndex = (index, category = 'gobierno') => {
  const images = exampleImages[category] || exampleImages.gobierno;
  return images[index % images.length];
};

















